"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotosDialog = PhotosDialog;
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _button = require("./button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PhotosDialog({
  photos,
  onClose,
  ...props
}) {
  const [selectedIndex, selectIndex] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (props.open) selectIndex(0);
  }, [props.open]);
  function handlePrev() {
    if (!photos) return;
    const size = photos.length;
    selectIndex(((selectedIndex - 1) % size + size) % size);
  }
  function handleNext() {
    if (!photos) return;
    selectIndex((selectedIndex + 1) % photos.length);
  }
  const photo = photos?.[selectedIndex];
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose(),
    slotProps: {
      paper: {
        sx: {
          borderRadius: 4
        }
      }
    }
  }, props), photo && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    alt: photo.title || '',
    src: photo.url || ''
  }), /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), photo.title && /*#__PURE__*/_react.default.createElement(StyledDialogTitle, null, photo.title), (photo.copyright || photo.description) && /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, photo.copyright && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, "\xA9 ", photo.copyright), photo.description && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, photo.description))), photos && photos.length > 1 && /*#__PURE__*/_react.default.createElement(StyledDialogActions, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    onClick: handlePrev,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.photos_dialog.actions.prev"
  })), /*#__PURE__*/_react.default.createElement(_button.Button, {
    onClick: handleNext,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.photos_dialog.actions.next"
  }))));
}
const StyledDialogTitle = (0, _styledComponents.styled)(_DialogTitle2.default)`
  padding-right: 46px;
`;
const CloseButtonWrapper = _styledComponents.styled.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledDialogActions = (0, _styledComponents.styled)(_DialogActions2.default)`
  justify-content: space-between;
`;